import { getSvgIcon, InterfaceIcon } from '@helpers/icons';
import { clamp } from '@helpers/utils';
import { withMotion } from '@hoc/withMotion';
import Button from '@stories/Components/Buttons/Button/Button';
import DropdownFilter from '@stories/Components/Listings/DropdownFilter/DropdownFilter';
import FormField from '@stories/Components/Misc/Forms/FormField';
import Select from '@stories/Components/Misc/Forms/Inputs/Select/Select';
import Searchbox from '@stories/Components/Misc/Searchbox/Searchbox';
import { AnimatePresence, MotionConfig } from 'framer-motion';
import * as React from 'react';
import S from './Filters.styles';
const Filters = (props) => {
    const [open, setOpen] = React.useState();
    const filterRefs = React.useRef([]);
    const [expanded, setExpanded] = React.useState(false);
    const count = props.filters?.reduce((previousLength, filter) => previousLength + filter.value.length, 0);
    const selectedFilters = React.useMemo(() => {
        return (props.filters
            ?.filter((filter) => filter.value.length > 0)
            .map((filter) => {
            return {
                ...filter,
                options: filter.options.filter((f) => filter.value.includes(f.value)),
            };
        }) ?? []);
    }, [count]);
    return (React.createElement(MotionConfig, { transition: { duration: 0.3, ease: 'easeOut' } },
        React.createElement(S.Container, { "data-show-filter-btn": props.filters && props.filters?.length > 3 },
            React.createElement(S.FiltersWrapper, { "data-expanded": expanded },
                React.createElement(S.Top, null,
                    getSvgIcon(InterfaceIcon.Filters),
                    props.translations?.['global.filters.filters'],
                    React.createElement(Button, { buttonType: "primary", icon: InterfaceIcon.Close, onClick: () => setExpanded(false), iconOnly: true }, props.translations?.['global.filters.close'])),
                props.filters?.map((filter, i) => {
                    if (i >= 3) {
                        return null;
                    }
                    return renderFilter(filter, i);
                }),
                (props.filters && props.filters.length > 3) ||
                    (props.filters && props.filters.length === 3 && props.searchInput) ? (React.createElement(S.ExtraWrapper, { initial: expanded ? 'opened' : 'closed', animate: expanded ? 'opened' : 'closed', variants: {
                        closed: {
                            height: 0,
                            overflow: 'hidden',
                            transitionEnd: {
                                visibility: 'hidden',
                            },
                        },
                        opened: {
                            visibility: 'visible',
                            height: 'auto',
                            transitionEnd: {
                                overflow: 'visible',
                            },
                        },
                    } },
                    props.filters.map((filter, i) => {
                        if (i < 3) {
                            return null;
                        }
                        return renderFilter(filter, i);
                    }),
                    renderSearch())) : (React.createElement(React.Fragment, null, renderSearch())),
                React.createElement(AnimatePresence, null, selectedFilters.length > 0 || (props.searchInput && !!props.searchInput.value) ? (React.createElement(S.SelectedWrapper, null,
                    selectedFilters.map((filter) => (React.createElement(React.Fragment, { key: `selected-${filter.id}` }, filter.options.map((option) => (React.createElement(S.SelectedOption, { key: `selected-${filter.id}-${option.value}`, initial: { y: `33%`, scale: 0.9, opacity: 0 }, animate: {
                            y: 0,
                            scale: 1,
                            opacity: 1,
                        }, exit: { y: `33%`, scale: 0.9, opacity: 0 }, onClick: () => filter.onChange?.(option.value) },
                        option.label,
                        getSvgIcon(InterfaceIcon.Close))))))),
                    props.searchInput?.value && (React.createElement(S.SelectedOption, { key: `selected-search`, onClick: () => props.searchInput?.onSubmit(''), initial: { y: `33%`, scale: 0.9, opacity: 0 }, animate: {
                            y: 0,
                            scale: 1,
                            opacity: 1,
                        }, exit: { y: `33%`, scale: 0.9, opacity: 0 } },
                        props.searchInput?.label,
                        ": ",
                        '"',
                        props.searchInput?.value,
                        '"',
                        getSvgIcon(InterfaceIcon.Close))),
                    selectedFilters.length > 0 || props.searchInput?.value ? (React.createElement(S.SelectedOption, { key: `selected-clear`, onClick: () => props.clearFilters(), initial: { y: `33%`, scale: 0.9, opacity: 0 }, animate: {
                            y: 0,
                            scale: 1,
                            opacity: 1,
                        }, exit: { y: `33%`, scale: 0.9, opacity: 0 }, "data-all": true },
                        props.translations?.['global.filters.clear'],
                        getSvgIcon(InterfaceIcon.Close))) : null)) : null)),
            React.createElement(Button, { buttonType: "tertiary", icon: InterfaceIcon.Filters, onClick: () => setExpanded(!expanded) },
                React.createElement("span", { "data-mobile": true },
                    props.translations?.['global.filters.filters'],
                    " (",
                    (count ?? 0) + (props.searchInput && !!props.searchInput.value ? 1 : 0),
                    ")"),
                React.createElement("span", { "data-desktop": true }, props.translations?.['global.filters.more'])),
            props.sortBy && (React.createElement(FormField, { label: props.sortBy?.label, showLabel: false, name: "sort-by-select" },
                React.createElement(Select, { id: "sort-by-select", value: props.sortBy.value ?? '', onChange: (event) => props.sortBy?.onChange(event.target.value) },
                    React.createElement("option", { value: "" }, props.sortBy?.label),
                    props.sortBy.options.map((option) => (React.createElement("option", { key: option.value, value: option.value }, option.label)))))),
            React.createElement(S.Bottom, null,
                React.createElement(Button, { buttonType: "tertiary", onClick: () => {
                        setExpanded(false);
                        setOpen(undefined);
                    } }, props.translations?.['global.filters.apply'])))));
    function renderFilter(filter, i) {
        return (React.createElement(DropdownFilter, { key: `${filter.id}-${i}`, ref: (el) => (filterRefs.current[i] = el), ...filter, isOpen: open === filter.id, onRightPress: () => {
                const maxIndex = expanded ? props.filters.length - 1 : 2;
                const nextIndex = i === maxIndex ? 0 : clamp(i + 1, maxIndex);
                filterRefs.current[nextIndex].focus();
            }, onLeftPress: () => {
                const maxIndex = expanded ? props.filters.length - 1 : 2;
                const prevIndex = i === 0 ? maxIndex : clamp(i - 1, maxIndex);
                filterRefs.current[prevIndex].focus();
            }, onEscapePress: () => {
                setOpen(undefined);
                filterRefs.current[i].focus();
            }, setOpen: (open) => {
                if (open) {
                    setOpen(filter.id);
                }
                else {
                    setOpen(undefined);
                }
            }, translations: props.translations, canFocus: i < 3 || expanded }));
    }
    function renderSearch() {
        if (!props.searchInput) {
            return null;
        }
        return (React.createElement(Searchbox, { idPrefix: "brand-card-listing-", label: props.searchInput.label, buttonLabel: props.searchInput.buttonLabel, placeholder: props.searchInput.placeholder, searchTerm: props.searchInput.value, onSubmit: props.searchInput.onSubmit, translations: props.translations, noTypeahead: true, cultureCode: "" }));
    }
};
export default withMotion(Filters);
